// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
export default function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/tap.js
// module id = VKSz
// module chunks = 0